// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2FYZq","content":"LayoutSettings_content__1B-0Q"};